module.exports = __webpack_public_path__ + "img/alert-icon.b053426d.svg";